export default __webpack_public_path__ + "static/media/Etape-5_MOULIN_DEF.b583cd65.mp3";